import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vShow as _vShow, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/Feithian.svg'
import _imports_1 from '@/assets/images/safeNet.svg'
import _imports_2 from '@/assets/images/DXToken.svg'
import _imports_3 from '@/assets/images/download.gif'


const _hoisted_1 = {
  id: "modal-token-a3",
  class: "modal modal-lg fade",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "modal-token-a3-body" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 2,
  class: "nav nav--wizard my-4 d-flex flex-row justify-content-center"
}
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = {
  key: 3,
  class: "token-choice"
}
const _hoisted_11 = { class: "form-token d-flex flex-row justify-content-center" }
const _hoisted_12 = { class: "form-check" }
const _hoisted_13 = { class: "form-check ms-3" }
const _hoisted_14 = { class: "form-check ms-3" }
const _hoisted_15 = { class: "form-check ms-3" }
const _hoisted_16 = { class: "img-tokens" }
const _hoisted_17 = {
  key: 4,
  class: "os-choice"
}
const _hoisted_18 = { class: "os-choice__images my-5" }
const _hoisted_19 = ["src"]
const _hoisted_20 = ["src"]
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "driver-choice d-flex flex-column" }
const _hoisted_23 = {
  key: 0,
  class: "text-start"
}
const _hoisted_24 = {
  key: 5,
  class: "final-modal-token d-flex flex-column justify-content-center"
}
const _hoisted_25 = { class: "text-start d-flex flex-row" }
const _hoisted_26 = { class: "text-start d-flex flex-row" }
const _hoisted_27 = { class: "text-start d-flex flex-row" }
const _hoisted_28 = { class: "text-start d-flex flex-row" }
const _hoisted_29 = ["href"]
const _hoisted_30 = { class: "modal-footer" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = {
  key: 0,
  class: "col-5 text-danger text-start"
}
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = {
  key: 2,
  class: "me-2 btn btn-outline-primary",
  href: "/ManualEmissaoA3.pdf",
  target: "_blank",
  type: "button"
}
const _hoisted_37 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Selectable = _resolveComponent("Selectable")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("button", {
              class: "btn-close",
              type: "button",
              "data-bs-dismiss": "modal",
              "aria-label": "Fechar"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[26] || (_cache[26] = _createElementVNode("div", { class: "modal-token-a3-fields" }, null, -1)),
              (_ctx.stepModal === 1 || _ctx.stepModal === 2)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_6, _cache[11] || (_cache[11] = [
                    _createTextVNode(" Vamos te ajudar a fazer o download do Driver "),
                    _createElementVNode("br", null, null, -1),
                    _createTextVNode(" referente ao seu Token! ")
                  ])))
                : (_openBlock(), _createElementBlock("h4", _hoisted_7, "Aguarde enquanto o download é concluído")),
              (_ctx.stepModal !== 3)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                    _createElementVNode("li", {
                      class: _normalizeClass(["nav-item", [
                  _ctx.stepModal === 2 ? 'nav--wizard__nav-item--success' : '',
                ]])
                    }, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["nav-link", [
                    _ctx.stepModal === 1 ? 'active' : '',
                    _ctx.stepModal === 2 ? 'disabled' : '',
                  ]]),
                        content: "1"
                      }, "Selecione o modelo do Chip", 2)
                    ], 2),
                    _createElementVNode("li", _hoisted_9, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["nav-link", [_ctx.stepModal === 2 ? 'active' : '']]),
                        content: "2"
                      }, "Selecione o Sistema Operacional", 2)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.stepModal === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _cache[16] || (_cache[16] = _createElementVNode("p", null, "Em qual Token está armazenado seu Certificado Digital?", -1)),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _withDirectives(_createElementVNode("input", {
                          id: "radioFeithian",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tokenChoice) = $event)),
                          class: "form-check-input form-check-input--success",
                          type: "radio",
                          name: "radioToken",
                          value: "Feithian",
                          checked: ""
                        }, null, 512), [
                          [_vModelRadio, _ctx.tokenChoice]
                        ]),
                        _cache[12] || (_cache[12] = _createElementVNode("label", {
                          class: "form-check-label",
                          for: "radioFeithian"
                        }, "Feithian", -1))
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _withDirectives(_createElementVNode("input", {
                          id: "radioSafenet",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tokenChoice) = $event)),
                          class: "form-check-input form-check-input--success",
                          type: "radio",
                          name: "radioToken",
                          value: "Safenet"
                        }, null, 512), [
                          [_vModelRadio, _ctx.tokenChoice]
                        ]),
                        _cache[13] || (_cache[13] = _createElementVNode("label", {
                          class: "form-check-label",
                          for: "radioSafenet"
                        }, "Safenet", -1))
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _withDirectives(_createElementVNode("input", {
                          id: "radioDXSafe",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tokenChoice) = $event)),
                          class: "form-check-input form-check-input--success",
                          type: "radio",
                          name: "radioToken",
                          value: "DXSafe"
                        }, null, 512), [
                          [_vModelRadio, _ctx.tokenChoice]
                        ]),
                        _cache[14] || (_cache[14] = _createElementVNode("label", {
                          class: "form-check-label",
                          for: "radioDXSafe"
                        }, "DXSafe", -1))
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _withDirectives(_createElementVNode("input", {
                          id: "radioGD",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tokenChoice) = $event)),
                          class: "form-check-input form-check-input--success",
                          type: "radio",
                          name: "radioToken",
                          value: "GD"
                        }, null, 512), [
                          [_vModelRadio, _ctx.tokenChoice]
                        ]),
                        _cache[15] || (_cache[15] = _createElementVNode("label", {
                          class: "form-check-label",
                          for: "radioGD"
                        }, "G+D", -1))
                      ])
                    ]),
                    _cache[17] || (_cache[17] = _createElementVNode("p", { class: "mt-2" }, [
                      _createTextVNode(" Compare o "),
                      _createElementVNode("strong", null, "modelo do seu Token"),
                      _createTextVNode(" para selecionar o driver correto ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("img", {
                        class: _normalizeClass(_ctx.tokenChoice == 'Feithian' ? 'show-img' : 'hide-img'),
                        src: _imports_0,
                        alt: "Imagem de um token Feithian"
                      }, null, 2),
                      _createElementVNode("img", {
                        src: _imports_1,
                        alt: "Imagem de um token Safenet",
                        class: _normalizeClass(_ctx.tokenChoice == 'Safenet' ? 'show-img' : 'hide-img')
                      }, null, 2),
                      _createElementVNode("img", {
                        src: _imports_2,
                        alt: "Imagem de um token DXSafe",
                        class: _normalizeClass(_ctx.tokenChoice == 'DXSafe' ? 'show-img' : 'hide-img')
                      }, null, 2),
                      _createElementVNode("img", {
                        src: _imports_0,
                        alt: "Imagem de um token G+D",
                        class: _normalizeClass(_ctx.tokenChoice == 'GD' ? 'show-img' : 'hide-img')
                      }, null, 2)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.stepModal === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _cache[18] || (_cache[18] = _createElementVNode("p", null, "Escolha abaixo o Sistema Operacional do seu computador", -1)),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.operationalSystem = 'windowsOSSelected'))
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.windowsChecked,
                          alt: "Logo do Windows"
                        }, null, 8, _hoisted_19)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.operationalSystem = 'macOSSelected'))
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.macChecked,
                          alt: "Logo do MacOS"
                        }, null, 8, _hoisted_20)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.operationalSystem = 'linuxOSSelected'))
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.linuxChecked,
                          alt: "Logo do Linux"
                        }, null, 8, _hoisted_21)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      (_ctx.drivers.length > 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_23, " Agora selecione a Versão "))
                        : _createCommentVNode("", true),
                      _withDirectives((_openBlock(), _createBlock(_component_Selectable, {
                        key: _ctx.selectableCount,
                        modelValue: _ctx.driverChoice,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.driverChoice) = $event)),
                        options: _ctx.drivers,
                        label: "",
                        name: "index",
                        icon: "download",
                        "label-selectable": "nome",
                        placeholder: "Selecione o driver"
                      }, null, 8, ["modelValue", "options"])), [
                        [_vShow, _ctx.drivers.length > 0]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.stepModal === 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "d-flex flex-row justify-content-center" }, [
                      _createElementVNode("img", {
                        class: "my-3",
                        src: _imports_3,
                        alt: "Gif animado de download"
                      })
                    ], -1)),
                    _cache[25] || (_cache[25] = _createElementVNode("p", { class: "text-start my-3" }, [
                      _createElementVNode("strong", null, "Importante")
                    ], -1)),
                    _createElementVNode("p", _hoisted_25, [
                      _createVNode(_component_Icon, {
                        class: "icon-check",
                        name: "circle-check"
                      }),
                      _cache[19] || (_cache[19] = _createElementVNode("span", null, [
                        _createTextVNode("Enquanto isso, certifique-se de que sua mídia esteja "),
                        _createElementVNode("strong", null, "desconectada"),
                        _createTextVNode(" do seu computador para prosseguir com a instalação.")
                      ], -1))
                    ]),
                    _createElementVNode("p", _hoisted_26, [
                      _createVNode(_component_Icon, {
                        class: "icon-check",
                        name: "circle-check"
                      }),
                      _cache[20] || (_cache[20] = _createElementVNode("span", null, "Após a conclusão do Download, execute o arquivo instalado e avance as etapas até concluir a instalação do programa.", -1))
                    ]),
                    _createElementVNode("p", _hoisted_27, [
                      _createVNode(_component_Icon, {
                        class: "icon-check",
                        name: "circle-check"
                      }),
                      _cache[21] || (_cache[21] = _createElementVNode("span", null, [
                        _createTextVNode("Após a instalação do programa, "),
                        _createElementVNode("strong", null, "insira a mídia no computador.")
                      ], -1))
                    ]),
                    _createElementVNode("p", _hoisted_28, [
                      _createVNode(_component_Icon, {
                        class: "icon-check",
                        name: "circle-check"
                      }),
                      _createElementVNode("span", null, [
                        _cache[22] || (_cache[22] = _createTextVNode("Em seguida, ")),
                        _createElementVNode("a", { href: _ctx.getLinkEmissor }, "faça o download do emissor", 8, _hoisted_29),
                        _cache[23] || (_cache[23] = _createTextVNode(" e siga os passos até a conclusão da instalação e a gravação dos dados do Certificado Digital em sua mídia."))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              (_ctx.hasDriversAndNoHasOS)
                ? (_openBlock(), _createElementBlock("p", _hoisted_32, " Não há driver encontrado para este Sistema Operacional "))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["text-end", _ctx.hasDriversAndNoHasOS ? 'col-7' : 'col-12'])
              }, [
                (_ctx.stepModal === 2)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-outline-primary",
                      type: "button",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.stepModal--))
                    }, " Voltar "))
                  : _createCommentVNode("", true),
                (_ctx.stepModal === 1 || _ctx.stepModal === 2)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: _normalizeClass(["ms-2 btn btn-primary", _ctx.getColorButton]),
                      disabled: _ctx.driverChoice === '' && _ctx.stepModal === 2,
                      type: "button",
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.downloadDriver && _ctx.downloadDriver(...args)))
                    }, [
                      (_ctx.stepModal === 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Avançar"))
                        : _createCommentVNode("", true),
                      (_ctx.stepModal === 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, "Fazer download do drive"))
                        : _createCommentVNode("", true),
                      (_ctx.stepModal === 1)
                        ? (_openBlock(), _createBlock(_component_Icon, {
                            key: 2,
                            class: "ms-2",
                            name: "arrow-right"
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.stepModal === 2)
                        ? (_openBlock(), _createBlock(_component_Icon, {
                            key: 3,
                            class: "ms-2",
                            name: "download"
                          }))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_33))
                  : _createCommentVNode("", true),
                (_ctx.stepModal === 3)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_36, [
                      _createVNode(_component_Icon, {
                        class: "me-2",
                        name: "up-right-from-square"
                      }),
                      _cache[27] || (_cache[27] = _createElementVNode("span", null, "Abrir guia de instalação", -1))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.stepModal === 3)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 3,
                      class: "btn btn-primary",
                      href: _ctx.getLinkEmissor,
                      target: "_blank",
                      type: "button"
                    }, [
                      _cache[28] || (_cache[28] = _createElementVNode("span", null, "Baixar emissor", -1)),
                      _createVNode(_component_Icon, {
                        class: "ms-2",
                        name: "download"
                      })
                    ], 8, _hoisted_37))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("button", {
      class: "btn-desktop btn btn-primary mt-3",
      type: "button",
      "data-bs-target": "#modal-token-a3",
      "data-bs-toggle": "modal",
      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.stepModal = 1))
    }, [
      _createVNode(_component_Icon, {
        class: "me-2",
        name: "download"
      }),
      _cache[30] || (_cache[30] = _createElementVNode("span", null, "Baixar driver", -1))
    ])
  ], 64))
}